import { render, staticRenderFns } from "./feeds.vue?vue&type=template&id=3cfe888b&"
import script from "./feeds.vue?vue&type=script&lang=js&"
export * from "./feeds.vue?vue&type=script&lang=js&"
import style0 from "./feeds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports